import {User} from './user';
import {Administration} from './administration';

export class Session {
  loggedIn: boolean;
  user: User;
  administration: Administration;
  availableAdministrations: Administration[];
  permissions: string[];

  public isLoggedIn(): boolean {
    return this.loggedIn;
  }
}
